import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { AxiosError, isAxiosError } from 'axios';

import sendErrorReport from 'common/utils/sendErrorReport';

export const buildQueryClient = () => {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error: Error, query) => {
        sendErrorReport(error, 'query', { queryKey: query.queryKey, meta: query.meta });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error: Error, variables, _, mutation) => {
        sendErrorReport(error, 'mutation', { variables, meta: mutation.meta });
      },
    }),
    defaultOptions: {
      queries: {
        retry: retryFn,
      },
    },
  });
};

const RETRY_COUNT = 3;

const isServerError = (error: AxiosError) => !!error.response && error.response.status >= 500;
const retryFn = (failureCount: number, error: unknown) => {
  if (!!isAxiosError(error)) {
    return isServerError(error) && failureCount <= RETRY_COUNT;
  }
  return failureCount <= RETRY_COUNT;
};
